export const APPLE_STORE_URL = 'https://apps.apple.com/de/app/camper-trader/id6502217594'
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=org.campertrader.app'
